import { useQueryClient } from '@tanstack/react-query';
import { LogOut } from 'lucide-react';
import { api } from '@/lib/api/client';
import { useSessionEmail } from './AuthGate';

export function LogoutButton() {
  const queryClient = useQueryClient();
  const email = useSessionEmail();

  async function deconnecter() {
    await api('/auth/logout', { method: 'POST' });
    // Tout le cache est purgé, pas seulement la session : il contient les
    // leads et les runs du compte qui vient de se déconnecter.
    queryClient.clear();
  }

  return (
    <div className="flex items-center gap-3">
      {email ? <span className="text-xs text-secondary">{email}</span> : null}
      <button
        type="button"
        onClick={deconnecter}
        title="Se déconnecter"
        className="flex items-center gap-1.5 rounded-control px-2 py-1 text-xs text-secondary hover:bg-sunken hover:text-primary"
      >
        <LogOut className="size-3.5" aria-hidden />
        Déconnexion
      </button>
    </div>
  );
}
